// extracted by mini-css-extract-plugin
export default {"circleIndent":"CircularProgress_circleIndent__3O2KR"};